import * as i18next from 'react-i18next';

export function useTranslation() {
    return i18next.useTranslation('webeoc-downloads');
}
